export class AccountingPlanLedgerPostsAmounts {

	public productPlanId: string = '';
	public accountingPlanId: string = '';
	public openAmount = 0;
	public closedAmount = 0;

	constructor(productPlanId:string, accountingPlanId:string, open: number, closed:number) {	
		this.productPlanId = productPlanId;
		this.accountingPlanId = accountingPlanId;
		this.openAmount = open;
		this.closedAmount = closed;
	}
}

export class AccountingPlansLedgerPostsAmounts {
	private _plansAmount: AccountingPlanLedgerPostsAmounts[] = [];
	
	constructor() {
	}

	get(accountingPlanId: string) {
		return this._plansAmount.find(a => a.accountingPlanId == accountingPlanId)
	}

	add(productPlanId: string, accountingPlanId: string, openAmount: number, closedAmount: number){
		let entry = this.get(accountingPlanId);
		if (entry) {
			entry.openAmount += openAmount;
			entry.closedAmount += closedAmount;
		} else {
			this._plansAmount.push(new AccountingPlanLedgerPostsAmounts(productPlanId, accountingPlanId, openAmount, closedAmount));
		}
	}

	hasOpenAmount(productPlanId: string) {
		return this._plansAmount.find(a => a.productPlanId == productPlanId)?.openAmount ?? 0 > 0;
	}

	openAmount(accountingPlanId: string): number {
		return this.get(accountingPlanId)?.openAmount ?? 0;
	}

	closedAmount(accountingPlanId: string): number {
		return this.get(accountingPlanId)?.closedAmount ?? 0;
	}

	totalOpenAmounts() {
		return Array.from(this._plansAmount.values()).map(a => a.openAmount).reduce((partialSum, amount) => partialSum + amount, 0) ?? 0;

	}
	totalClosedAmounts() {
		return Array.from(this._plansAmount.values()).map(a => a.closedAmount).reduce((partialSum, amount) => partialSum + amount, 0) ?? 0;
	}

	filterByProductPlans(productPlanIds: string[]) {
		this._plansAmount = this._plansAmount.filter(amount => productPlanIds.find(id => amount.productPlanId == id));
	}
}